module.exports = __webpack_public_path__ + "img/test_r7.d7fe2726.png";